import { render, staticRenderFns } from "./Podlazie.vue?vue&type=template&id=e928d16e&scoped=true"
import script from "./Podlazie.vue?vue&type=script&lang=js"
export * from "./Podlazie.vue?vue&type=script&lang=js"
import style0 from "./Podlazie.vue?vue&type=style&index=0&id=e928d16e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e928d16e",
  null
  
)

export default component.exports